import {ApolloProvider} from "@apollo/client";
import {CookiesProvider} from "react-cookie";
import {IconContext} from "react-icons";
import {Outlet} from "react-router";

import {UserContextProvider} from "@/components/context/UserContextProvider.tsx";
import client from "@/lib/api/apolloClient.ts";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";

const ProtectedEmptyLayout = () => (
  <UpErrorBoundary>
    <ApolloProvider client={client}>
      <CookiesProvider>
        <UserContextProvider>
          <IconContext.Provider value={{size: "1.25em", style: {verticalAlign: "text-top"}}}>
            <UpErrorBoundary>
              <Outlet />
            </UpErrorBoundary>
          </IconContext.Provider>
        </UserContextProvider>
      </CookiesProvider>
    </ApolloProvider>
  </UpErrorBoundary>
);
export default ProtectedEmptyLayout;
